import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getFundraiser = () => axios.get(`${API}/fundraiser`).then((r) => r.data);
export const getRecentDonations = () => axios.get(`${API}/donations/recent`).then((r) => r.data);
export const getGofundmeProgress = () => axios.get(`${API}/gofundme/progress`).then((r) => r.data);
